import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { SearchEmailPayload, SearchEmailResponse } from './search-emails.types';

export async function searchEmailService({ query: search }: SearchEmailPayload) {
  const query = transformIntoQueryParamString(search);

  const { response, data } = await BACKEND.get<SearchEmailResponse>(ENDPOINT.SILO_PERMISSION_PREDICTIVE, {
    query,
  });

  return {
    response,
    summary: data,
  };
}
